<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>Dashboard</li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-y-auto">
  <iframe title="HAWK_Dashboard_BI" width="1920" height="1080" src="https://app.powerbi.com/view?r=eyJrIjoiMzYxZjI5NjUtODNkYS00NjEzLWI4YmUtMGM1ZmZkNzdmOWRhIiwidCI6IjhhMDgzZTNjLTg1ZGQtNGM0YS05MjlkLTA2ZmYxNTIyODdkYiIsImMiOjl9&pageName=b26c07f6766844485964" frameborder="0" allowFullScreen="true"></iframe>
</div>
